<div class="warn-message-container">
  <mat-icon color="warn">error</mat-icon>
  <div class="warn-message">
    <ng-content></ng-content>
  </div>
  <button mat-icon-button (click)="dismiss.emit()"><mat-icon color="warn">close</mat-icon></button>
</div>
